import React, { ReactElement } from 'react';

import { VideoProviderEnum } from 'features/contents';
import { VimeoPlayer, ProtectedVideoPlayer, YoutubePlayer, PandaPlayer } from './components';
import { VideoPlayerProps } from './types';
import SambaPlayer from './components/sambaPlayer/SambaPlayer';

declare global {
  interface Window {
    VdoPlayer: any;
    playerContainer: any;
    vdo: any;

    pandascripttag: any;
    PandaPlayer: any;
    SambaPlayer: any;

    eventListener: (player: any) => void;
    sambaPlayer: any;
  }
}

const Player = ({ videoProvider, ...props }: VideoPlayerProps): ReactElement => {
  return (
    <>
      {videoProvider === VideoProviderEnum.Vimeo && <VimeoPlayer videoProvider={videoProvider} {...props} />}

      {videoProvider === VideoProviderEnum.ProtectedVideo && <ProtectedVideoPlayer videoProvider={videoProvider} {...props} />}

      {videoProvider === VideoProviderEnum.Youtube && <YoutubePlayer videoProvider={videoProvider} {...props} />}

      {videoProvider === VideoProviderEnum.Panda && <PandaPlayer videoProvider={videoProvider} {...props} />}

      {videoProvider === VideoProviderEnum.SambaVideo && <SambaPlayer videoProvider={videoProvider} {...props} />}
    </>
  );
};
export default Player;
